import {BirthdayMember} from '../../types/birthdays'
import {BirthdayListItem} from './BirthdayListItem'
import './BirthdayModal.css'

interface BirthdayModalProps {
  birthdays: BirthdayMember[]
  date: Date
  onClose: () => void
  onOpenPreview?: (id: string) => void
}

export const BirthdayModal = ({birthdays, date, onClose, onOpenPreview}: BirthdayModalProps) => {
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  }).format(date)

  return (
    <div className='birthday-modal-backdrop' onClick={onClose}>
      <div className='birthday-modal-content' onClick={(e) => e.stopPropagation()}>
        <div className='birthday-modal-header'>
          <h3 className='birthday-modal-title'>
            <i className='bi bi-cake2 me-2'></i>
            Birthdays on {formattedDate}
          </h3>
          <button className='birthday-modal-close' onClick={onClose}>
            <i className='bi bi-x-lg'></i>
          </button>
        </div>
        <div className='birthday-modal-body'>
          {birthdays.map((birthday) => (
            <BirthdayListItem
              key={birthday.id}
              birthday={birthday}
              onOpenPreview={onOpenPreview}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
